import React from "react"
import { Link } from "react-router-dom"
import "./modernHomeSections.css"

const homeOptions = [
  {
    title: "Signature Townhomes",
    meta: "3-4 beds / family living",
    image: "/images/list/p-4.png",
    text: "Low-maintenance homes with generous bedrooms, private outdoor space, and secure community planning.",
  },
  {
    title: "City Apartments",
    meta: "1-3 beds / rental-ready",
    image: "/images/list/p-1.png",
    text: "Bright apartments positioned for convenient living, strong rental demand, and everyday ease.",
  },
  {
    title: "Custom Builds",
    meta: "Design / permits / build",
    image: "/images/list/p-7.png",
    text: "Start with your land, lifestyle, and budget, then let our team shape the plan from concept to keys.",
  },
]

const amenities = [
  {
    icon: "fa-solid fa-location-dot",
    title: "Connected locations",
    text: "Explore homes near major roads, schools, business hubs, and growing residential enclaves.",
  },
  {
    icon: "fa-solid fa-tree",
    title: "Outdoor living",
    text: "Prioritize gardens, terraces, balconies, and shared green pockets that make homes feel breathable.",
  },
  {
    icon: "fa-solid fa-shield-halved",
    title: "Secure communities",
    text: "Discover gated homes, managed access, and practical layouts built for long-term peace of mind.",
  },
  {
    icon: "fa-solid fa-bolt",
    title: "Future-ready features",
    text: "Plan for efficient lighting, water systems, smart-home readiness, and energy-conscious upgrades.",
  },
]

const ModernHomeSections = () => {
  return (
    <>
      <section className='home-options padding'>
        <div className='container'>
          <div className='section-kicker'>Explore home options</div>
          <div className='section-split'>
            <h2>Choose a path that matches the way you want to live.</h2>
            <p>
              Inspired by modern community-led property sites, this homepage now gives visitors
              a faster way to compare buying, renting, and building without digging through menus.
            </p>
          </div>

          <div className='home-options__grid'>
            {homeOptions.map((option) => (
              <article className='home-option' key={option.title}>
                <img src={option.image} alt={option.title} loading='lazy' decoding='async' />
                <div className='home-option__content'>
                  <span>{option.meta}</span>
                  <h3>{option.title}</h3>
                  <p>{option.text}</p>
                  <Link to='/listings'>See details</Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className='lifestyle-story'>
        <div className='container lifestyle-story__inner'>
          <div className='lifestyle-story__media'>
            <img src='/images/banner.png' alt='Modern residential community' loading='lazy' decoding='async' />
          </div>
          <div className='lifestyle-story__copy'>
            <span className='section-kicker'>Sustainable luxury</span>
            <h2>Homes should feel refined, practical, and ready for tomorrow.</h2>
            <p>
              Vista Hill Houses brings listings and custom build services together, so clients can
              move quickly when the right home exists and still have a clear path when they want
              something built around them.
            </p>
            <div className='lifestyle-story__points'>
              <span>Adaptive layouts</span>
              <span>Energy-aware planning</span>
              <span>Indoor-outdoor living</span>
            </div>
          </div>
        </div>
      </section>

      <section className='amenities padding'>
        <div className='container'>
          <div className='section-kicker'>Amenities and services</div>
          <div className='section-split'>
            <h2>More than property search: a full living experience.</h2>
            <p>
              Give visitors reasons to trust the platform: location guidance, lifestyle features,
              secure communities, and build-ready support.
            </p>
          </div>

          <div className='amenities__grid'>
            {amenities.map((item) => (
              <article className='amenity' key={item.title}>
                <i className={item.icon}></i>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className='tour-cta'>
        <div className='container tour-cta__inner'>
          <div>
            <span className='section-kicker'>Find your dream home today</span>
            <h2>Ready to tour, compare, or start a custom build?</h2>
          </div>
          <Link to='/contact'>Schedule a tour</Link>
        </div>
      </section>
    </>
  )
}

export default ModernHomeSections
